
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './index.p.css';

const sizeStyles = {
  "xs": styles.sizeXS,"s": styles.sizeS,"m": styles.sizeM,"l": styles.sizeL
}

export const Size = {
  "xs": "xs","s": "s","m": "m","l": "l"
};

const GitHubIcon = React.forwardRef(
  ({ theme, size, className, ...props }, ref) => {return (<svg viewBox="0 0 24 24" {...props} className={cn(styles.icon, styles[theme], sizeStyles[size], className)} ref={ref}><path d="M9.32 20.698a.293.293 0 00.284-.042.31.31 0 00.119-.266v-1.75a3.86 3.86 0 01-1.91 0 1.858 1.858 0 01-1.207-1.234 1.74 1.74 0 00-.805-1.029 1.026 1.026 0 01-.503-.617s.1-.308.604-.206c.502.103.905.515 1.407 1.338a1.924 1.924 0 002.213.514c.002-.244.036-.485.1-.72.06-.245.202-.463.402-.617a3.863 3.863 0 01-3.921-3.497 4.262 4.262 0 01.905-3.6 2.885 2.885 0 01.2-2.469h.101c.842.09 1.642.41 2.313.926a8.086 8.086 0 014.425 0 7.19 7.19 0 012.413-.926 2.996 2.996 0 01.201 2.469 4.434 4.434 0 01.905 3.6 3.784 3.784 0 01-3.921 3.497 1.648 1.648 0 01.502 1.234v3.086a.404.404 0 00.247.382c.05.02.102.03.156.03a9.17 9.17 0 006.435-8.846 9.102 9.102 0 00-9-9.155 9.103 9.103 0 00-9 9.155 9.05 9.05 0 006.336 8.742z" /></svg>)}
);

GitHubIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["xs", "s", "m", "l"])
};

GitHubIcon.defaultProps = {
  size: "m"
};

export default GitHubIcon;